const principles = [
  {
    icon: "ri-stack-line",
    title: "Clean Architecture",
    description:
      "Systems are designed with clear separation of concerns, modular components, and well-defined interfaces. This architectural discipline ensures that software remains maintainable, testable, and adaptable as requirements evolve over time without accumulating technical debt.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Performance Optimization",
    description:
      "Every component is scrutinized for efficiency — from memory management and rendering pipelines to network throughput and battery impact. The team profiles, measures, and iterates relentlessly to deliver software that feels responsive and performs reliably under real-world conditions.",
  },
  {
    icon: "ri-user-heart-line",
    title: "User-Centered Design",
    description:
      "Technical excellence means nothing if the software is difficult to use. Design decisions are grounded in usability principles, accessibility standards, and a deep understanding of how people interact with digital interfaces. The goal is always clarity, consistency, and delight in every interaction.",
  },
];

export default function PrinciplesSection() {
  return (
    <section className="relative w-full py-24 md:py-32 lg:py-40 bg-background-100">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16">
          <span className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-400 font-medium">
            Core Principles
          </span>
          <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight max-w-2xl">
            The foundations of every system we build
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {principles.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-lg p-8 md:p-10 flex flex-col"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-6">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-semibold text-foreground-950 mb-4">
                {item.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}